{
  "name": "@upscopeio/twilio-flex-component",
  "version": "2025.2.24",
  "description": "Upscope Co-browsing component for Twilio Flex",
  "main": "./dist/UpscopeWidget.js",
  "license": "MIT",
  "scripts": {
    "component:build": "yarn build && jq '.main = \"./UpscopeWidget.js\"' package.json > dist/package.json",
    "build": "rm -rf .parcel-cache; parcel build src/index.tsx",
    "dev:watch": "parcel watch src/index.tsx"
  },
  "keywords": [
    "Upscope",
    "Cobrowse",
    "Twilio"
  ],
  "author": "dev@upscope.io",
  "dependencies": {
    "@sentry/browser": "^7.112.2",
    "@sentry/react": "^7.44.2",
    "@sentry/tracing": "^7.44.2",
    "@twilio/flex-ui": "^2.8.2",
    "axios": "^1.6.8",
    "case-converter": "^1.0.1",
    "debug": "^4.3.4",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "react-timeago": "^7.1.0"
  },
  "devDependencies": {
    "@parcel/optimizer-data-url": "^2.12.0",
    "@parcel/transformer-css": "^2.12.0",
    "@parcel/transformer-inline-string": "^2.12.0",
    "@parcel/transformer-svg-react": "^2.8.3",
    "@types/axios": "^0.14.0",
    "@types/debug": "^4.1.12",
    "@types/react": "^18.2.14",
    "@types/react-dom": "^18.2.14",
    "@types/react-timeago": "^4.1.7",
    "parcel": "^2.8.3",
    "typescript": "5.0.4"
  },
  "@parcel/transformer-css": {
    "cssModules": {
      "global": true
    }
  }
}
